import { APIService } from "./api";
import { API } from "@/lib/api";
import { ReadInvoicingCompany } from "@/types/invoicingCompany";

export const InvoicingCompanyService = new APIService<ReadInvoicingCompany>(
  API.InvoicingCompanies,
);
export const fetchInvoicingCompanyList = InvoicingCompanyService.getList;
export const fetchInvoicingCompany = InvoicingCompanyService.get;
